<app-header></app-header>
<div class="our-worlds">
    <p class="title-our-world">Marketplace</p>
    <div class="line-our-world"></div>

    <!-- Caracteristicas -->
    <div class="our-worlds-container">
        <div class="side-right-ferias">
            <p class="title-side-right-ferias">CARACTERISTICAS</p><br>
            <div class="row">
                <div class="col-12 col-lg-6 padding-ten-right lg-padding-five-right md-padding-15px-right md-margin-five-bottom wow fadeIn border-right border-color-extra-medium-gray text-align-center"
                    style="visibility: visible; animation-name: fadeIn;">
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Mayor visibilidad digital. </div>
                                <br><br>
                            </div>
                        </div>
                    </div>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Este modelo permite escalar y exhibir los todos
                                    productos de la marca, así aumente su portafolio. Básicamente, no hay límites.</div>
                                <br>
                            </div>
                        </div>
                    </div>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Mayor diversidad de clientes.</div>
                                <br><br>
                            </div>
                        </div>
                    </div>
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">El Marketplace también es eficiente a la hora de
                                    fidelizar los clientes, puesto que se ofrecen herramientas necesarias para que crees
                                    acciones que le agreguen valor a la experiencia del usuario con tu marca. </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 padding-ten-left lg-padding-five-left md-padding-15px-left md-margin-five-bottom wow fadeIn"
                    style="visibility: visible; animation-name: fadeIn;">
                    <div class="icon-box d-table w-100 mx-auto mx-lg-0 last-paragraph-no-margin">
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Puedes tener tu marca o producto en varios
                                    Marketplace, siempre y cuando tengan un perfil compatible con la marca, lo que
                                    genera mayor alcance.
                                </div>
                                <br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">El sistema permite conectarse de forma on line
                                    con la base de datos para actualizar los inventarios de cada tienda.
                                </div>
                                <br>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 element-imp">
                                <img src="../assets/images/icon-p.png">
                            </div>
                            <div
                                class="col-lg-10 icon-box-holder align-middle d-table-cell position-relative paddin-10">
                                <div class="txt-align-caracteristicas">Sincronización de los datos con el stock de todos
                                    los canales de venta.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Fin caracteristicas -->

    <!-- Beneficios -->
    <div class="our-worlds-container">
        <div class="side-right-ferias">
            <p class="title-side-right-ferias">BENEFICIOS</p>
            <div class="row">
                <div class="col-12 col-lg-4 col-md-6 text-center"
                    style="visibility: visible; animation-name: fadeInUp;">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios"><b>Practicidad</b> en un mismo sitio web, se pueden ver todas las
                        ofertas de varias marcas. De esa forma, es posible comparar y elegir el mejor precio fácilmente.
                    </div>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center" data-wow-delay="0.2s"
                    style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInUp;">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">No se necesita tener un Centro Comercial físico. </div>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Se puede comprar en diferentes tiendas y <b>realizar solo un
                            pago</b>, en
                        lugar de pasar por múltiples procesos de pago en varios sitios.
                    </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Al anunciar los productos en un Marketplace, las marcas - sean
                        grandes o pequeñas - ganan más <b>visibilidad</b> y consiguen aumentar las ventas</div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Cuando una marca más pequeña y no tan conocida coloca su producto
                        en el Marketplace de un gigante del mercado, se consigue ganar confianza y se <b>Reputación</b>
                        ante el consumidor. </div>

                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img class="img-fondo" src="../assets/images/ok.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">El Marketplace <b>aumenta las ventas</b> mientras <b>reduce
                            los costos</b>, potenciando, de esa forma, la rentabilidad, puesto que no requiere altos
                        costos de Tecnología. Kaleidolab que se encarga de la tecnología, administración, desarrollo y
                        hospedaje.
                    </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
            </div>
        </div>
    </div>
    <!-- Fin beneficios -->

    <!-- Funcionalidades -->
    <div class="our-worlds-container">
        <div class="side-right-ferias">
            <p class="title-side-right-ferias">Funcionalidades</p>
            <br>
            <div class="row">
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Configuración de la vista general del Marketplace. </div><br><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Posibilidad de definir lista clientes públicos o privados.
                    </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">El comprador del paquete otorgar roles a quienes administran el
                        Marketplace o a los locales comerciales. </div>

                </div>
                <!-- end service item -->
                <!-- start service item -->
                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Administración de la publicidad y visibilidad dentro del
                        Marketplace. </div><br>
                </div>
                <!-- end service item -->
                <!-- start service item -->

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Configuración de marcas o locales. </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Configuración de Avatar por marca o local. </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 text-center">
                    <img src="../assets/images/funcionalidades.png" width="50px" height="50px"><br><br>
                    <div class="txt-align-beneficios">Configurar todos los productos en las estanterías y la posibilidad
                        de cambiar la visibilidad de las mismas. </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Fin funcionalidades -->

</div>
<app-footer></app-footer>